import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';

@Component({
  selector: 'app-column-tiny-spacer',
  templateUrl: './column-tiny-spacer.component.html',
  styleUrls: ['./column-tiny-spacer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnTinySpacerComponent extends ColumnComponent {}
